import { openBlock, createElementBlock, normalizeClass, renderSlot } from "vue";
/* empty css                 */
const _sfc_main = {
  __name: "Headband",
  props: {
    type: {
      type: String,
      validator(value) {
        return ["information", "sub-information", "warning", "marketing"].includes(value);
      },
      default: "information"
    }
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(["headband", [`${__props.type}`]])
      }, [
        renderSlot(_ctx.$slots, "default")
      ], 2);
    };
  }
};
export {
  _sfc_main as default
};
//# sourceMappingURL=Headband.vue.es.js.map
